module.exports = __webpack_public_path__ + "img/juncao.20b7ec09.svg";